import React, { useEffect, useState } from 'react'

import { Rights } from 'app/accountUserContextConstants'
import { useAccountUserContext } from 'app/useAccountUserContext'
import { useWorkspaceContext } from 'app/WorkspaceContext'
import * as roleUtils from 'features/auth/utils/roleUtils'
import publicAsset from 'utils/publicAsset'

import { Button } from 'ui/components/Button'
import {
    Modal,
    ModalContent,
    ModalFooter,
    ModalFooterButtonGroup,
    ModalHeader,
} from 'ui/components/Modal'

const STORAGE_KEY = 'support_moved_modal_seen'

export const SupportMovedModal: React.FC = () => {
    const { user, hasRight } = useAccountUserContext()
    const { workspaceAccount } = useWorkspaceContext()

    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        if (user && workspaceAccount && !localStorage.getItem(STORAGE_KEY)) {
            setIsOpen(true)
        }
    }, [user, workspaceAccount])

    const handleClose = () => {
        localStorage.setItem(STORAGE_KEY, 'true')
        setIsOpen(false)
    }

    const canContact = Boolean(
        user && !roleUtils.isPortalUser(user) && hasRight(Rights.ContactSupport)
    )

    if (!user || !workspaceAccount || !canContact) {
        return null
    }

    return (
        <Modal open={isOpen} onOpenChange={(open) => !open && handleClose()}>
            <ModalContent>
                <ModalHeader
                    title="Support has moved!"
                    subtitle={
                        <>
                            You can now access Stacker support by clicking on{' '}
                            <strong>Help&nbsp;&amp;&nbsp;Support</strong> icon in the sidebar. You
                            can still search the knowledge base or start a new chat as usual.
                        </>
                    }
                    coverImage={{
                        src: publicAsset('/static/media/new_help_location.png'),
                        alt: 'Illustration showing the new Help & Support icon location',
                    }}
                    showCloseButton={false}
                />
                <ModalFooter>
                    <ModalFooterButtonGroup>
                        <Button size="l" variant="primary" onClick={handleClose}>
                            Understood
                        </Button>
                    </ModalFooterButtonGroup>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}
